/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.localeSelect = this.form.querySelector('select[name="locale_code"]');
      this.countryField = this.form.querySelector('[name="country_code"]');
      this.inputs = this.form.querySelectorAll('select[name="locale_code"], select[name="country_code"]');
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 200);
      this.inputs.forEach(item => item.addEventListener('change', this.debouncedOnSubmit.bind(this)));
    }
    onSubmitHandler(event) {
      if (event && event.target === this.localeSelect && this.countryField) {
        const countryCode = this.localeSelect.selectedOptions[0]?.dataset.countryCode;
        if (countryCode) this.countryField.value = countryCode;
      }
      if (this.form) this.form.submit();
    }
  }
  customElements.define('localization-form', LocalizationForm);
}